import React from 'react';

import './styles.scss';

interface DriverLogRowProps {
  order?: string;
  client?: string;
  createAt?: string;
  expirationDate?: string;
  transporter: string;
}

export function DriverLogRow({ order, client, createAt, expirationDate, transporter }: DriverLogRowProps) {
  return (
    <div className="driver__info">
      <div className="driver__info--container">
        <div className="driver__info--header">
          <p className="driver__info--paragraph">Expiração: {expirationDate}</p>
        </div>

        <div className="driver__info--body">
          <p className="driver__info--paragraph order">
            Pedido: <span>{order}</span>
          </p>

          <div>
            <p className="driver__info--paragraph client">
              Cliente: <span>{client}</span>
            </p>

            <p className="driver__info--paragraph permission">
              Permissão: {createAt}
            </p>
          </div>

          <p className="driver__info--paragraph transporter">
            Transportadora: <span>{transporter}.</span>
          </p>
        </div>
      </div>
    </div>
  );
}
